import { LOCATION_CHANGE } from 'connected-react-router';

import {
  pageNameFromRouterPath,
  pageTitleFromRouterPath,
  referrer,
} from 'app/router/selectors';
import { isUserAuthenticated } from 'app/features/user/selectors';

const page = {
  [LOCATION_CHANGE]: (getState, { payload }) => ({
    type: 'page',
    name: pageNameFromRouterPath(getState()),
    properties: {
      isAuthenticated: isUserAuthenticated(getState()),
      url: window.location.href,
      path: payload.location.pathname,
      referrer: referrer(getState()),
      title: pageTitleFromRouterPath(getState()),
    },
  }),
};

export default page;
